import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import type { Manga } from 'src/services/apollo/generated/graphql'
import MangaLikeButton from '../Common/MangaLikeButton'

const MangaViewerFooter: FC<{
  manga: Manga
}> = ({ manga }) => {
  const { t } = useTranslation(['manga'])

  return (
    <div className="bg-background w-full min-h-[300px] flex flex-col items-center justify-center">
      <MangaLikeButton manga={manga} />
      <div className="opacity-40 text-lg pt-4">{t('manga:interesting')}</div>
    </div>
  )
}

export default MangaViewerFooter
